module.exports = __webpack_public_path__ + "static/img/logo-qlc.0a08751b.png";